import { axiosInstance } from '../App';

import { GetItemsProps } from "medere-ui-framework";
import { ComboDataDTO } from '../dto/ComboDataDTO';

export function getCities({offSet, filterValue, pageSize}:GetItemsProps){
    const qParams = new URLSearchParams({
        inputText: filterValue ?? "",
        offSet: offSet?.toString() ?? "",
        pageSize: pageSize?.toString() ?? "",
    })


    return axiosInstance.get(
        '/api/secured/locations/getCities', {
            params: qParams
        })
        .then(res => {
            return res.data;
        }).catch((error) => {
            console.error(error);
            throw error;
        });
}

export function getDefaultCity(){


    return axiosInstance.get(
        '/api/secured/locations/getDefaultCity', {
        })
        .then(res => {
            return {
                id: res.data?.city ?? -1,
                name: res.data?.description ?? '',
                isExternalId: false,
            } as ComboDataDTO;
        }).catch((error) => {
            console.error(error);
            throw error;
        });
}

export function getAllAddressByMedereEntity({filterValue = "", params}:GetItemsProps<{
    medereentity?: number
}>){
    const qParams = new URLSearchParams({
        inputText: filterValue,
        medereentity: params?.medereentity?.toString() ?? "",
    })

    return axiosInstance.get('/api/secured/locations/getAllAddressByMedereEntity',{ params: qParams }).then(res => res.data).catch((error) => {
        console.error(error);
        throw error;
    })
}

export function getAllAddressByMedereEntityAndType({filterValue = "", params}:GetItemsProps<{
    medereentity?: number,
    addresstype?: number
}>){
    const qParams = new URLSearchParams({
        inputText: filterValue,
        medereentity: params?.medereentity?.toString() ?? "",
        addresstype: params?.addresstype?.toString() ?? "",
    })

    return axiosInstance.get('/api/secured/locations/getAllAddressByMedereEntityAndType',{ params: qParams }).then(res => res.data).catch((error) => {
        console.error(error);
        throw error;
    })
}

export function getCitiesFromMedereData({offSet, filterValue, pageSize}:GetItemsProps){
    const qParams = new URLSearchParams({
        inputText: filterValue ?? "",
        offSet: offSet?.toString() ?? "0",
        pageSize: pageSize?.toString() ?? "20",
        languageid: "1",
    })

    return axiosInstance.get(
        '/api/secured/locations/getCitiesFromMedereData', {
            params: qParams
        })
        .then(res => {
            return (res.data ?? []).map((item: ComboDataDTO) => ({
                ...item,
                isExternalId: true,
            }));
        }).catch((error) => {
            console.error(error);
            throw error;
        });
}
